export default __webpack_public_path__ + "static/media/info-icon.2c047a67.svg";